import StationsStore from "../stores/StationsStore";
import GenericRALocalStorageStore from "../stores/GenericRALocalStorageStore";

class StationAdoptStore {

    storageKey = 'StationAdoptStore';
    store = new GenericRALocalStorageStore(this.storageKey);

    async getStationId() {
        const adoptInfo = await this.read();
        if (!adoptInfo?.data?.stationId)
            throw 'Station not assigned';
        const stationId = adoptInfo.data.stationId;
        return stationId;
    }



    async isAdopted() {
        var info = await this.store.read();
        return info.data.stationId;
    }

    async save(record) {

        var data = record.data;

       if (!data.stationId) {
           console.log(data);
            throw('Station Adoption Not Complete - no stationId');
        }

        var stationData = await new StationsStore().findBySiteId(data.stationId);
        console.log('Found station', {stationData});

        if (!stationData.data) {
            throw 'Station not found: ' + data.stationId;
        }

        const toSave = {
            stationId: data.stationId,
        }

        return this.store.save(toSave);
    }

    async read() {
        return this.store.read();
    }

    async remove() {
        return this.store.remove();
    }


}

export default StationAdoptStore;
